import { createFileRoute } from '@tanstack/react-router'
import DateRangePickerWithPresets from '@/components/inputs/DateRangePickerWithPresets'
import { RangeValue, DateValue, Button } from '@heroui/react'
import { useState } from 'react'
import dayjs from 'dayjs'
import { parseDate } from '@internationalized/date'
import GDDChart from '@/components/field/insights/GDDChart'
import RootDensityChart from '@/components/field/insights/RootDensityChart'
import VegetativeTrendline from '@/components/field/insights/VegetativeTrendline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable, faChartBar } from "@fortawesome/free-solid-svg-icons"
import VegetativeTable from '@/components/field/insights/VegetativeTable'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/development',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const [dateRange, setDateRange] = useState<RangeValue<DateValue> | null>({
    start: parseDate(dayjs().subtract(2, 'weeks').format('YYYY-MM-DD')),
    end: parseDate(dayjs().format('YYYY-MM-DD')),
  })
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="flex flex-col gap-2">
      <DateRangePickerWithPresets value={dateRange} onChange={setDateRange} label="Date Range" />
      <GDDChart dateRange={dateRange} />
      <div className="flex flex-row items-center justify-end">
        <Button
          isIconOnly
          size="sm"
          variant="flat"
          onPress={() =>
            setShowTable(!showTable)
          }
          aria-label="Toggle Table"
        >
          <FontAwesomeIcon
            icon={!showTable ? faTable : faChartBar}
          />
        </Button>
      </div>
      {!showTable ? (<VegetativeTrendline dateRange={dateRange} />) : <VegetativeTable dateRange={dateRange} />}
      <RootDensityChart dateRange={dateRange} />
    </div>
  )
}
